// src/actions/applicationActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../api/http'; // <-- central axios instance with baseURL & token

// Fetch applications from the backend
export const fetchApplications = createAsyncThunk(
  'applications/fetchApplications',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await http.get('/applications');
      return data;
    } catch (error) {
      const msg = error.response?.data?.error || error.message;
return rejectWithValue(msg);
    }
  }
);

export const fetchAllApplicationsDetails = createAsyncThunk(
  'applications/fetchAllApplicationsDetails',
  async (_, { rejectWithValue }) => {
    try {
      console.log('🔍 Fetching applications...');
      const { data } = await http.get('/applications/getAllApplicationDetails');
      console.log('✅ API Data:', data);
      return data;
    } catch (error) {
      console.error('❌ API Fetch Error:', error);
      const msg = error.response?.data || error.message;
      return rejectWithValue(msg);
    }
  }
);

// Fetch an application information from the backend with an ID parameter
export const getApplicationInformation = createAsyncThunk(
  'applications/getApplicationInformation',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await http.get(`/applications/getApplicationInformation/${id}`);
      return data;
    } catch (error) {
      const msg = error.response?.data || error.message;
      return rejectWithValue(msg);
    }
  }
);

// Create a new application
export const createApplication = createAsyncThunk(
  'applications/createApplication',
  async (applicationData, { rejectWithValue }) => {
    try {
      console.log('Payload being sent to API:', applicationData);
      const { data } = await http.post('/applications/createApp', applicationData);
      console.log('Response from API:', data);
      return data;
    } catch (error) {
      console.error('Error from API:', error);
      const msg = error.response?.data || error.message;
      return rejectWithValue(msg);
    }
  }
);

// Delete an application by ID
export const deleteApplication = createAsyncThunk(
  'applications/deleteApplication',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await http.delete(`/applications/${id}`);
      return data;
    } catch (error) {
      const msg = error.response?.data || error.message;
      return rejectWithValue(msg);
    }
  }
);

// Update application and then refetch full list with details
export const updateApplication = createAsyncThunk(
  'applications/updateApplication',
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      console.log("🔧 Thunk updateApplication – ID:", id);
      console.log("🔧 Thunk updateApplication – updatedData:", updatedData);

      // 1) update
      await http.put(`/applications/${id}`, updatedData);

      // 2) refetch everything with details so frontend is in sync
      const { data } = await http.get('/applications/getAllApplicationDetails');
      console.log("✅ Refetched apps after update:", data);

      return data; // full array of applications-with-details
    } catch (error) {
      console.error("❌ Update Application Error:", error);
      const msg = error.response?.data || error.message;
      return rejectWithValue(msg);
    }
  }
);